import { FC } from 'react'
import microApp from '@micro-zoe/micro-app'

const _window = window as any
/**
 * 控制导航权限
 * @param param0
 * @returns
 */
export const AuthPermission: FC<{ Code: string; children: React.ReactElement }> = ({ Code, children }) => {
  let globalData = null
  if (_window.__MICRO_APP_BASE_APPLICATION__) {
    // 主应用获取全局数据
    globalData = microApp.getGlobalData() // 返回全局数据
  } else {
    // 子应用获取全局数据
    globalData = _window.microApp.getGlobalData() // 返回全局数据
  }

  const { permissions = [] } = globalData || {}

  if (!Code) {
    return null
  }

  const [navCode, permissionCode] = Code.split(':')

  const permission = permissions.find((p: any) => p.navCode === navCode && p.permissionCode === permissionCode)
  if (permission) {
    return children
  }

  return null
}
